import React from 'react';
import { Link } from 'react-router-dom';
import OurNetwork from '../../containers/landingPage/Patient/DigitalDentalDesign';
import PatientBenefitsDesktop from '../../containers/landingPage/Patient/PatientBenefitsDesktop';
import PatientBenefitsMobile from '../../containers/landingPage/Patient/PatientBenefitsMobile';
import PatientBenefitsV2 from '../../containers/landingPage/Patient/PatientBenefitsV2';
import OurServices from '../../containers/landingPage/Patient/ServicesCards';
import MainBannerPat from '../../components/landingPage/MainBanner/Slides/Patient/MainBannerPat';
import HeaderNavbar from '../../containers/landingPage/HeaderNavbar';
import TestimonialsPat from '../../containers/landingPage/Patient/TestimonialsPat'
import ScanAndGo from '../../containers/landingPage/Patient/ScanAndGo';
import CovidGuidelines from '../../containers/landingPage/Patient/CovidGuidelines';
import ContactUsSection from '../../containers/landingPage/ContactUsSection';
import Footer from '../../containers/landingPage/Footer';
import GoDigital from '../../containers/landingPage/Patient/GoDigitalPat';
import { isMobile } from 'react-device-detect';
import TreatmentPlans from '../../containers/landingPage/Patient/TreatmentPlans';
import ClinicsProvider from '../../store/clinics/clinicsProvider';


function LandingPagePatient() {

  return (
    <div className="overflow-x-hidden text-lg">
      <HeaderNavbar logo="blue&black" menuIcon="blue" patient/>
      <MainBannerPat/>
      <OurNetwork/>
      <ScanAndGo/>
      <OurServices/>
      <GoDigital/>
      <PatientBenefitsV2/>
      <TreatmentPlans/>
      <TestimonialsPat/>
      <CovidGuidelines/>
      <ClinicsProvider>
        <ContactUsSection/>
      </ClinicsProvider>
      <Footer light/>
    </div>
  )
}

export default LandingPagePatient
